<!-- Píldora de la topbar (prototipo `showMini` / `showPending`): círculo blanco de 28 px + texto 13px/700. -->
<button *ngIf="variant" type="button" class="fp-pill" [class.fp-pill--verify]="variant === 'verify'" (click)="open()" [disabled]="opening">
    <span class="fp-pill__icon">
        <img *ngIf="variant === 'activate'" src="assets/img/fina-pago/isotipo.svg" alt="" />
        <i-feather *ngIf="variant === 'verify'" name="clock"></i-feather>
    </span>
    <span class="fp-pill__label">{{ label }}</span>
</button>
